import { render, staticRenderFns } from "./home5.vue?vue&type=template&id=53708c65&scoped=true&"
import script from "./home5.vue?vue&type=script&lang=js&"
export * from "./home5.vue?vue&type=script&lang=js&"
import style0 from "./home5.vue?vue&type=style&index=0&id=53708c65&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53708c65",
  null
  
)

export default component.exports